import React from 'react';
import PropTypes from 'prop-types';
import CategoryNameComponent from "../CategoryNameComponent.jsx";
import MaterialIcon from "../../elements/MaterialIcon.jsx";

export default function CategorySummaryNameDisplay({ budget, category, dragHandleProps, editingTypes, highlighted, onClick, showDragHandle, showingDetailedSummaryInformation }) {
	return <React.Fragment>
		<div
			className={`col s1 ${showDragHandle ? "" : "hide"}`} {...(dragHandleProps)} >
			<MaterialIcon>drag_indicator</MaterialIcon>
		</div>
		{!editingTypes &&
		<div
			className={`${showingDetailedSummaryInformation ? "" : "clickable"} category_name col s6`}
		>
			<div
				className='category_name_container'
			>
				{!!budget.notes && !highlighted &&
				<MaterialIcon className='has_note'>note</MaterialIcon>
				}
				<CategoryNameComponent
					className={showingDetailedSummaryInformation ? "clickable" : undefined}
					onClick={onClick}
					category={category}
					suffix={showingDetailedSummaryInformation ? <MaterialIcon
						className='right'>arrow_drop_down</MaterialIcon> : undefined}
				/>
			</div>
			{!!budget.notes && highlighted &&
			<div className='category_budget_notes'>
				{budget.notes}
			</div>
			}
		</div>
		}
	</React.Fragment>;
}

CategorySummaryNameDisplay.propTypes = {
	showDragHandle: PropTypes.any,
	dragHandleProps: PropTypes.any,
	editingTypes: PropTypes.bool,
	showingDetailedSummaryInformation: PropTypes.any,
	budget: PropTypes.any,
	highlighted: PropTypes.any,
	onClick: PropTypes.func,
	category: PropTypes.any,
	categoryBudgetChangeCanBeSubmitted: PropTypes.any,
	submittingBudgetAmountChange: PropTypes.bool,
	hasChanges: PropTypes.any,
};